"use client";
import Link from "next/link";
import React, { useEffect, useRef } from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";
import { ROUTE_GIFTCARD } from "@/utils/constants";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "@/utils/localStorageUtils";
import { ScanToOrderInfo } from "@/dto/scanToOrderInfo";
import { LocalStorageKey } from "@/utils/storageKeys";
import { useRouter } from "next/navigation";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { useTranslations } from "next-intl";

export interface CheckoutCartHeaderProps {
  redirectToGiftCard: boolean;
  isRunningTabsEnabled: boolean;
}

export const CheckoutHeader = ({
  redirectToGiftCard,
  isRunningTabsEnabled,
}: CheckoutCartHeaderProps) => {
  const t = useTranslations("CheckoutHeader");
  const router = useRouter();
  const scanToOrderInfo = getFromLocalStorage<ScanToOrderInfo | null>(
    LocalStorageKey.SCAN_TO_ORDER_INFO,
    null
  );
  const headerRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.focus();
    }
  }, []);

  const clearScanToOrderCart = () => {
    if (scanToOrderInfo && isRunningTabsEnabled) {
      removeFromLocalStorage(LocalStorageKey.RESTAURANT_CART);
    }
  };

  const handleBackClick = () => {
    clearScanToOrderCart();
    router.back();
  };

  return (
    <div
      data-testid={applyDataTestId(pom.checkout.checkoutHeader)}
      className={[
        "hidden",
        "sm:flex",
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "bg-white",
        "shadow-md",
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        {!redirectToGiftCard && (
          <button
            ref={headerRef}
            type="button"
            onClick={handleBackClick}
            data-testid={applyDataTestId(
              pom.checkout.checkoutNavigationReturnButton
            )}
          >
            <div
              className={["flex", "flex-row", "gap-3", "items-center"].join(
                " "
              )}
            >
              <ArrowLeftIcon />
              <span className="text-[20px] font-medium text-[#373737]">
                {t("back")}
              </span>
            </div>
          </button>
        )}
        {redirectToGiftCard && (
          <Link href={ROUTE_GIFTCARD} onClick={clearScanToOrderCart}>
            <div
              className={["flex", "flex-row", "gap-3", "items-center"].join(
                " "
              )}
            >
              <ArrowLeftIcon />
              <span className="text-[20px] font-medium text-[#373737]">
                {t("back")}
              </span>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};
